import type {PermissionsRecordType} from '../permissions';

export const saleVehiclePermissions = {
  saleVehicleBackgroundRemoval: {
    resourceId: 'SALE_VEHICLE_PHOTO_ALBUM',
    actionId: 'REMOVE_PHOTOS_BACKGROUND',
    scopes: [],
  },
  readPhotoCheckerReport: {
    resourceId: 'PHOTO_CHECKER_REPORT',
    actionId: 'READ',
    scopes: [],
  },
  createPhotoCheckerReport: {
    resourceId: 'PHOTO_CHECKER_REPORT',
    actionId: 'CREATE',
    scopes: [],
  },
} satisfies PermissionsRecordType;
